import React,{useEffect,useState} from 'react';
import './styles/App.css';
import bag_check from './img/bag_check.png';
import TopTitle from './TopTitle';
import queryString from 'query-string'
import more from './img/more.png';
import {comma, instance} from './common';
import CheckCart from './components/ServiceAll/CheckCart';
import Cart_bg from './components/ServiceAll/Cart_bg';
// import NotFound from './NotFound';

function ServiceAll({location,history}) {
  // user logged in or anonymous
  let res = window.sessionStorage.result || JSON.stringify({
    u_type: 'anonymous',
    u_id: -1
   });
  let session = JSON.parse(res);
  let {u_type,u_id} = session;
  
  const query = queryString.parse(location.search);
  console.log('query : ', query)
  let cate = (query.cate === 'sungard') ? '썬가드하이퍼이벤트' : ( (query.cate === 'hyundai') ? '현대캐피탈서비스' : 'BtoB' );
  // TODO: '페이지 없음' 페이지 추가
  // let cate = '';
  // if (query.cate === 'sungard') cate = '썬가드하이퍼이벤트';
  // else if (query.cate === 'hyundai') cate = '현대캐피탈서비스';
  // else if (query.cate === 'BtoB') cate = 'BtoB';
  // else return <NotFound />;
  
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const page = 1;
  const [ppp, setPpp] = useState(10);
  const [cartLength, setCartLength] = useState(0);
  const [cartData, setCartData] = useState([]);

  useEffect(() => {

    let obj = {
      s_cate:cate,
      page:page,
      ppp:ppp
    }
    instance.post('/service/cate',obj).then(function(res){
        setData(res.data.rows);
        setTotal(res.data.totalCount);
      });
  }, [ppp]);

    const ab = {
      position:'absolute',
      right:'15px',
      top:'1.5rem',
      color:'#06f',
      fontSize:'10px'
    }

    const cart = {
      position:'absolute',
      right:'15px',
      bottom:'1.5rem',
      width:'20px'
    }
    const wordBreak = {
      wordBreak:'keep-all'
    }
    const w60 = {
      width:'60%',
      verticalAlign:'top'
    }
    const w30 = {
      width:'40%'
    }

    const moreCss = {
      width:'35px'
    }


    const moreInfo = () => {
      setPpp(ppp+4);
    }


    const goService = (e) => {
      const {id} = e.target.dataset;
      if(query.r_id){
        history.push('/service?s_id='+id+'&r_id='+query.r_id);
      }else{
        history.push('/service?s_id='+id);
      }
      
    }


    const bgSet = {
      backgroundPosition:'center',
      backgroundSize:'cover',
      backgroundRepeat:'no-repeat',
      width:'85px',
      height:'85px',
      borderRadius:'5px',
      display:'inline-block',
    }

    const goCart = (e) => {
      const {id,name} = e.target.dataset;
      
      const obj = {s_id:id,u_id:u_id};
      const fetchData = async () => {
        instance.post('/cart/insert',{obj:obj}).then(function(res){
              if(res.data.msg === "해당 상품이 추가되었습니다."){
                setCartLength(cartLength+1);
                
              }else if(res.data.msg === '해당 상품이 삭제되었습니다.'){
                setCartLength(cartLength-1);
                
              }
              
              alert(res.data.msg);
          });
      
      };
  
      fetchData();
      
  
    }

    const onClickCart = () => {
      if (u_id === -1) {
        alert('로그인이 필요합니다');
      } else if(query.r_id){
        history.push('/cart?r_id='+query.r_id);
      } else{
        history.push('/cart');
      }
    }

  return (
    <>
     <TopTitle title={`${cate} 상품`}/>   
      <div className="cotainer mb-5">
          <div className="text-right mr-4 mb-2" style={{position:'relative'}}>
            {(u_type === '카마스터' || u_type === '일반고객') && <span className="mb-3"  onClick={onClickCart}>
              <img src={bag_check} style={{width:'31px',verticalAlign:'bottom'}}/>
              <CheckCart 
              u_id={u_id} 
              cartData={cartData} 
              setCartData={setCartData}
              cartLength={cartLength}
              setCartLength={setCartLength}
              />
            </span>}
          </div>
          <div className="row p-0">
            {
              data.map(v =><div className="col-12 service-div pt-4 pb-3 pr-5" key={v.s_id} data-id={v.s_id}>
              <div className="" data-id={v.s_id}>
                <div  data-id={v.s_id} style={{...bgSet, backgroundImage:'url(\''+v.s_img+'\')'}}></div><div  data-id={v.s_id}  className=" d-inline-block"  style={{...w60,...wordBreak,verticalAlign:'top'}}>
                  <h4 className="text-primary font-weight-bold ml-3 pr-5" data-id={v.s_id} style={{ fontSize:"12px" }} onClick={goService}>{v.s_name}</h4>
                  <div  data-id={v.s_id} style={{marginTop:'30px'}}>
                    {
                      query.cate === 'sungard'
                      ?
                      <>
                        <h5  data-id={v.s_id} className="font-weight-bold ml-3 text-lightgray" style={{textDecoration: 'line-through'}}>소비자가 : {comma(v.s_price)}</h5>
                        <h4  data-id={v.s_id} className="font-weight-bold ml-3">특별 할인가 : {comma(v.s_member_price)}</h4>
                      </>
                      :
                      u_type === '카마스터'
                      ?
                      <>
                        <h5  data-id={v.s_id} className="font-weight-bold ml-3 text-lightgray" style={{textDecoration: 'line-through'}}>소비자가 : {comma(v.s_price)}</h5>
                        <h4  data-id={v.s_id} className="font-weight-bold ml-3">특별 할인가 : {comma(v.s_member_price)}</h4>
                      </>
                      :
                      <h4  data-id={v.s_id} className="font-weight-bold ml-3">소비자가 : {comma(v.s_price)}</h4>
                    }
                    
                  </div>
                </div>
                <span data-id={v.s_id} style={ab} onClick={goService}>제품상세보기</span>
                {(u_type === '카마스터' || u_type === '일반고객') && <Cart_bg u_id={u_id} s_id={v.s_id} goCart={goCart} s_name={v.s_name} cart={cart}/>}
                
              </div>
          </div>)
            }
              
          </div>
          <div className="text-center mt-3">
            {
              total != data.length && <img style={moreCss} src={more} onClick={moreInfo}/>
            }
            
          </div>
      </div>
    </>
  );
}

export default ServiceAll;